import requestProvider from "./axiosHandler";

const getAllAddresses = () => {

    return requestProvider
        .get("/customer-address/get-all")
}

const getAddressByCustomerId = (customerId) => {
    return requestProvider
        .get(`/customer-address/get-by-customer/${customerId}`)
}

const getAddressById = (addressId) => {
    return requestProvider
        .get(`/customer-address/${addressId}`)
}

const createAddress = (list) => {
    return requestProvider
        .post('/customer-address', list)
}

const deleteAddress = (id) => {

    return requestProvider
        .delete(`/customer-address/${id}`)
}

const updateAddress = (list) => {

    return requestProvider
        .put('/customer-address',list)
}

const findByAddress = (list) => {

    return requestProvider
        .post('/customer-address/find-by-address', list)
}
export {getAllAddresses, getAddressByCustomerId, createAddress, deleteAddress, getAddressById, updateAddress, findByAddress}